// removed by extract-text-webpack-plugin
module.exports = {"root":"_1bE65","label":"VBhYS","input":"_24PSq","errorInput":"_1ndux","errorLabel":"_2v6vZ"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Fields/TextField/TextField.scss
// module id = 208
// module chunks = 0 1